import { render } from "./SocialMediaButtons.vue?vue&type=template&id=77179ba7&scoped=true"
const script = {}

import "./SocialMediaButtons.vue?vue&type=style&index=0&id=77179ba7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77179ba7"]])

export default __exports__